// extracted by mini-css-extract-plugin
module.exports = {"menu":"Layout_menu__o90aa","main":"Layout_main__evUHx","menuCollapsed":"Layout_menuCollapsed__WLXV_"};